import { Component, OnInit, TemplateRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { ParticipantData } from 'app/models/enterprise-model';
import { UserDataService } from 'app/services/user-data.service';
import { InitialiseService } from 'app/services/initialise.service';
import { ChatService } from 'app/services/chat.service';
import { WriteService } from 'app/services/writes.service';
import { IconsService } from 'app/services/icons.service';
import { AdminService } from 'app/services/admin.service';
import { NotificationService } from 'app/services/notification.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var $: any;
@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})

export class ContactsComponent implements OnInit {
  userId: string;
  public newContact = true;
  public editProfile = true;
  newMember;
  results = [];
  value = '';
  modalRef: any;
  modalRef2: any;
  

  constructor(public afs: AngularFirestore, public usd: UserDataService, public is: InitialiseService, public ns: NotificationService,
    public cs: ChatService, public ws: WriteService, public modalService: NgbModal, public ico: IconsService, public ad: AdminService) {
    this.dataCall();
    // newMember: any = {
    //   name: '',
    //   address: '',
    //   nationalId: '',
    //   nationality: '',
    //   phoneNumber: '',
    //   id: '',
    //   photoURL: '',
    //   bus_email: '',
    // }
  }

  dataCall() {
  }

  UrlExists(url, cb) {
    $.ajax({
      url: url,
      dataType: 'text',
      type: 'GET',
      complete: function (xhr) {
        if (typeof cb === 'function') {
          cb.apply(this, [xhr.status]);
        }
      }
    });
    return cb
  }

  openLgg(template: TemplateRef<any>) {
      this.modalRef2 = this.modalService.open(template, { size: 'lg' })
  }

  searchresult() {
    this.afs.collection<ParticipantData>('Users').valueChanges().subscribe(users => {
      this.layWord(users, this.value);
    })
  }

  layWord(allUsers, value) {
    let word = value; const results = [];
    allUsers.forEach(man => {
      if (man.name) {
        // man.name = man.name.toLowerCase();
        const name = man?.name?.toLowerCase();
        if (word !== '' || ' ') {
          word = word.toLowerCase();
          if (name?.includes(word)) {
            // man.name = man.name.charAt(0).toUpperCase() + man.name.slice(1);
            results.push(man);
            // console.log(results);
            this.results = results;
            const exist = this.usd?.myContacts.find((item) => item.id === man.id);
            if (exist) {
              man.join = true;
              // console.log('true');
            } else {
              // console.log('false');
              man.join = false;
            }
          }
        }
      }
      return this.results;
    });
  }

  layWordAch(coll: any[]) {
    let word = this.value; const results = [];
    coll.forEach(man => {
      // man.name = man.name.toLowerCase();
        const name = man?.name?.toLowerCase();
      if (word !== '' || ' ') {
        word = word.toLowerCase();
        if (name?.includes(word)) {
          // man.name = man.name.charAt(0).toUpperCase() + man.name.slice(1);
          this.results = results;
          const usr = this.usd?.myContacts.find(us => us.id === man.id);
          const usrIndex = this.usd?.myContacts.findIndex(us => us.id === man.id);
          if (usrIndex > -1) {
            man.join = true;
            results.push(man);
            console.log('true');
          } else {
            console.log('false');
            man.join = false;
            results.push(man);
          }
        }
      }
      return this.results;
    });
  }

  ngOnInit(): void {
  }

}
